import { createStructuredSelector } from 'reselect';
import {
  arbitratorSelector,
  notesSelector,
  arbitratorDetailFormSelector,
  getArbitratorSelectorData,
} from '../../selectors/arbitrator';
import { userStatusSelector } from '@selectors/global';
import {
  viewOnlySelector,
} from '@modules/appraisal/selectors/global';

export default createStructuredSelector({
  formValues: arbitratorDetailFormSelector,
  initialValues: getArbitratorSelectorData,
  notes: notesSelector,
  arbitrator: arbitratorSelector,
  userStatus: userStatusSelector,
  viewOnly: viewOnlySelector,
});
